import { useState } from 'react';
import { LOCAL_STORAGE_KEYS } from '../constants/localStorage';

type LocalStorageKey = keyof typeof LOCAL_STORAGE_KEYS;

export function useLocalStorage<T>(key: LocalStorageKey, initialValue: T) {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = localStorage.getItem(LOCAL_STORAGE_KEYS[key]);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error('Error reading from localStorage:', error);
      return initialValue;
    }
  });

  const setValue = (value: T) => {
    try {
      setStoredValue(value);
      localStorage.setItem(LOCAL_STORAGE_KEYS[key], JSON.stringify(value));
    } catch (error) {
      console.error('Error writing to localStorage:', error);
    }
  };

  return [storedValue, setValue] as const;
} 